import React from 'react';

const InterviewGuidelinesModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000,
      fontFamily: 'Inter, sans-serif',
      animation: 'fadeIn 0.3s ease-out',
    }}>
      <div style={{
        width: '90%',
        maxWidth: '600px',
        maxHeight: '90vh',
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '24px',
        boxShadow: '0px 25px 50px -12px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(17, 24, 39, 0.1)',
        animation: 'slideDown 0.4s ease-out',
        overflowY: 'auto',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '16px',
          borderBottom: '1px solid #e5e7eb',
          paddingBottom: '16px'
        }}>
          <h2 style={{
            fontSize: '22px',
            fontWeight: '600',
            margin: 0,
            color: '#111827'
          }}>🎯 Interview Guidelines: Do's & Don'ts</h2>
          <button
            onClick={onClose}
            style={{
              display: 'flex',
              height: '32px',
              width: '32px',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '6px',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f7fafc'}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Content */}
        <div style={{
          marginBottom: '24px'
        }}>
          <div style={{
            marginBottom: '24px'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#047857',
              display: 'flex',
              alignItems: 'center',
              marginBottom: '16px'
            }}>
              <span style={{ marginRight: '8px' }}>🟢</span> Do's
            </h3>
            <ul style={{
              paddingLeft: '24px',
              margin: '0',
              color: '#374151',
              fontSize: '16px',
              lineHeight: '1.6'
            }}>
              <li style={{ marginBottom: '12px' }}>
                <strong>Stick to the interview topics only.</strong> Avoid unrelated technical or personal discussions.
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Use Chrome browser</strong> for the best compatibility and audio/video stability.
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Take the interview on a laptop or desktop.</strong> Avoid using mobile devices.
              </li>
              <li style={{ marginBottom: '12px' }}>
                When Sarah asks, <strong>"Can we start the interview?"</strong>, reply clearly with:
                <div style={{
                  margin: '8px 0',
                  padding: '8px 12px',
                  backgroundColor: '#f3f4f6',
                  borderLeft: '4px solid #047857',
                  borderRadius: '4px',
                  fontWeight: '500'
                }}>
                  👉 "Yes, we can start the interview."
                </div>
                Then wait for Sarah to begin.
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Wait 3–5 seconds after responding</strong>, so Sarah can process and reply smoothly.
              </li>
              <li style={{ marginBottom: '0px' }}>
                After answering each question, Sarah will ask:
                <div style={{
                  margin: '8px 0',
                  padding: '8px 12px',
                  backgroundColor: '#f3f4f6',
                  borderLeft: '4px solid #047857',
                  borderRadius: '4px',
                  fontWeight: '500'
                }}>
                  👉 "If you're ready to move to the next question, please respond with 'Yes, I am ready.'"
                </div>
                Be sure to confirm before proceeding.
              </li>
            </ul>
          </div>

          <div>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#b91c1c',
              display: 'flex',
              alignItems: 'center',
              marginBottom: '16px'
            }}>
              <span style={{ marginRight: '8px' }}>🔴</span> Don'ts
            </h3>
            <ul style={{
              paddingLeft: '24px',
              margin: '0',
              color: '#374151',
              fontSize: '16px',
              lineHeight: '1.6'
            }}>
              <li style={{ marginBottom: '12px' }}>
                <strong>Don't refresh the tab or close the browser</strong> once the interview starts.
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Don't interrupt Sarah</strong> before she finishes speaking.
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Don't use vague responses</strong> — clarity improves your evaluation.
              </li>
              <li style={{ marginBottom: '0px' }}>
                <strong>Don't proceed to the next question</strong> without saying "Yes, I am ready."
              </li>
            </ul>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          borderTop: '1px solid #e5e7eb',
          paddingTop: '16px'
        }}>
          <button
            onClick={onClose}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '8px 16px',
              backgroundColor: '#000000',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#333333'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#000000'}
          >
            I understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default InterviewGuidelinesModal;
